var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/file_upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M34.5001 28.7501V34.5001H11.5001V28.7501H7.66675V34.5001C7.66675 36.6084 9.39175 38.3334 11.5001 38.3334H34.5001C36.6084 38.3334 38.3334 36.6084 38.3334 34.5001V28.7501H34.5001ZM13.4167 17.2501L16.1192 19.9526L21.0834 15.0076V30.6667H24.9167V15.0076L29.8809 19.9526L32.5834 17.2501L23.0001 7.66675L13.4167 17.2501Z",
    fill: "#003776"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.6cc1cac7de297807ef516e87162c384b.svg";
export { ForwardRef as ReactComponent };